import React, { useEffect, useRef, useState } from "react";
import EventIcon from '@mui/icons-material/Event';
import { Box, Button, Popover } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DateCalendar } from "@mui/x-date-pickers";
import { renderAlert } from "../../../../CommonComponents/Alert/Alert";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { checkForEmptyNotes } from "../../helper/helpersSubModule";
import { applyStylestoCellRenderer } from "../../helper/helperFunctions";


export const CustomDateRenderer = ({ params,columnSubType, updateRowDHelper,updateDB,isEditRowPopup, readOnlyMode, sheetType }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [calendarView, setCalendarView] = useState('day');
    const [isFocused, setIsFocused] = useState(false);
    let columnName=params.colDef.field+"_es"
    let cellFormatting=params.data ? (params.data[columnName]?.cellStyle || {}) : {}
    let cellFormat = params.data ? params.data[columnName]?.format : '';
    const cellStyles = applyStylestoCellRenderer(cellFormat);

    useEffect(() => {
        const checkFocus = () => {
          const focusedCell = params.api.getFocusedCell();
      
          setIsFocused(
            focusedCell &&
            focusedCell.rowIndex === params.node.rowIndex &&
            focusedCell?.column?.getColId() === params?.column?.getColId()
          );
        };
      
        checkFocus();
      
        params.api.addEventListener('cellFocused', checkFocus);
      
        return () => {
          params.api.removeEventListener('cellFocused', checkFocus);
        };
      }, [params]);
      

      const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
    
        if (
            columnSubType == "None" ||
            columnSubType == undefined ||
            params.node.allChildrenCount === null
        ) {
            setAnchorEl(event.currentTarget);
        } else {
            renderAlert(
                'This row has sub tasks and it cannot be edited directly.',
                'info'
            );
        }
    };


    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    let isStrictDate = params.colDef.listData || false

    function formatDate(date) {

        if (!date || typeof date === 'number') {
            return { value: isStrictDate ? "" : date, isDate: false };
        }
        const dateRegex = /^\d{4}-\d{2}-\d{2}$|^\d{1,2}[/-]\d{1,2}[/-]\d{4}$/;

        if (!dateRegex.test(date)) {
            if (!isNaN(parseInt(date))) {
                return { value: date, isDate: false };
            }
            return { value: isStrictDate ? "" : date, isDate: false };
        }
        if (isStrictDate) {
            return { value: date, isDate: true }
        }
        const parsedDate = new Date(date.replace('-', '/'));
        if (isNaN(parsedDate.getTime())) {
            return { value: "Invalid Date", isDate: false };
        }
        if (date.trim().length > 10) {
            return { value: 'Invalid Date', isDate: false };
        }
        const formattedDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
        const newDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
        return { value: isStrictDate ? formattedDate : newDate, isDate: true };
    }
    let { value, isDate } = formatDate(params.value)

    const handleDateChange = (date) => {
        const newdate = dayjs(date).format('MM/DD/YYYY')
        updateRowDHelper(newdate)
        if (calendarView === "day") {
            handleClose()
        }
    }

    const handleClear = () => {
        updateRowDHelper("")
        handleClose()
    }

    const handleYesterday = () => {
        const yesterday = dayjs().subtract(1, 'day').format('MM/DD/YYYY')
        updateRowDHelper(yesterday)
        handleClose()
    }

    const handleToday = () => {
        const today = dayjs().format('MM/DD/YYYY')
        updateRowDHelper(today)
        handleClose()
    }
    const handleTomorrow = () => {
        const tomorrow = dayjs().add(1, 'day').format('MM/DD/YYYY')
        updateRowDHelper(tomorrow)
        handleClose()
    }
    return (
        <div style={{...cellStyles, width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', fontSize: cellFormatting?.fontSize||'12px',color:cellFormatting?.color||"black", alignItems: 'center', fontFamily: cellFormatting?.fontFamily||"Arial" ,
        }}>
            <span>{value}</span>
            {isFocused && sheetType !== 'filterSheet' && !readOnlyMode && !params?.node?.data?.checkinagent && !params?.node?.data?.isAzureRow && params.colDef.editable !== false &&
                <EventIcon className={`date-opener-icon ${isEditRowPopup ? 'visible' : ''}`}
                sx={{
                    fontSize: "12px",
                    color: "#134157",
                    padding: "0px 2px",
                    cursor: "pointer",
                    pointerEvents: "auto"
                  }}

                    onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                    }}  />}
            {params?.colDef?.field && params?.data?.hasOwnProperty(params?.colDef?.field+'_es') && params?.data[params?.colDef?.field + "_es"]!==undefined && !checkForEmptyNotes(params?.data[params.colDef.field + "_es"]?.notes) &&
               <ArrowDropDownIcon style={{ position: 'absolute', top: 2, right: 22, color: '#3fd237', fontSize: '28px', transform: 'rotate(225deg)', transformOrigin: ' top right' }} onClick={(e) => { params.onClickOpenRightDrawer("notes", 0); }} />
            } 
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                        value={value !== "" && value !== null && value !== "Invalid Date" ? dayjs(value) : null}
                        onViewChange={(newView) => { setCalendarView(newView) }}
                        onChange={handleDateChange} sx={{ height: "16.5rem" }}
                        minDate={dayjs("01/01/1900")}
                        maxDate={dayjs("12/31/2099")} />
                </LocalizationProvider>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "0.75rem", paddingLeft: "0.25rem", paddingRight: "1.25rem" }}>
                    <Button onClick={handleClear} sx={{ fontSize: "0.75rem", padding: "0", textTransform: "none", fontWeight: "bold" }}>Clear</Button>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Button onClick={handleYesterday} sx={{ fontSize: "0.75rem", padding: "0", textTransform: "none", fontWeight: "bold" }}>Yesterday</Button>
                        <Button onClick={handleToday} sx={{ fontSize: "0.75rem", padding: "0", textTransform: "none", fontWeight: "bold" }}>Today</Button>
                        <Button onClick={handleTomorrow} sx={{ fontSize: "0.75rem", padding: "0", textTransform: "none", fontWeight: "bold" }}>Tomorrow</Button>
                    </Box>
                </Box>
            </Popover>
        </div>
    );
}